import { FCI_ERROR } from "@searchui-searchforms/shared/fci";
import { fciFetch } from "@/shared/lib/fci";
import type { Person, PersonDetails } from "./types";

export const getPerson = ({ personId, treeId }: PersonDetails) =>
    fciFetch<Person>(`/api/person-picker/person/${treeId}/${personId}`, {
        fci: {
            // Fetches person details for suggestions/quick-fill
            // If it fails, the user can still type in the form manually
            errorType: FCI_ERROR.Convenience,
            errorInfo: "getPerson",
        },
    });
